import React, { useState, useEffect } from 'react';
import { dataExportsAPI } from '../../../api';

const FrequencySelector = ({frequency, setFrequency, customStyles}) => {
  const [nextReportTimes, setNextReportTimes] = useState({ daily: '', weekly: '', monthly: '' });

  useEffect(() => {
    const fetchNextReportTimes = async () => {
      try {
        const response = await dataExportsAPI.get('/csv-delivery-settings/next-report-datetime');
        if (response.data && response.data.data) {
          const { daily, weekly, monthly } = response.data.data;
          setNextReportTimes({
            daily: daily ? new Date(daily).toLocaleString() : 'N/A',
            weekly: weekly ? new Date(weekly).toLocaleString() : 'N/A',
            monthly: monthly ? new Date(monthly).toLocaleString() : 'N/A',
          });
        }
      } catch (error) {
        console.error('Error fetching next report times:', error);
      }
    };

    fetchNextReportTimes();
  }, []);

  const handleButtonClick = (value) => {
    setFrequency((prevState) => {
      if (prevState.includes(value)) {
        // Remove the value if it already exists
        return prevState.filter((item) => item !== value);
      } else {
        // Add the value if it doesn't exist
        return [...prevState, value];
      }
    });
  };

  // Sort the selected array to ensure the correct sequence
  const sortedSelected = frequency.sort((a, b) => {
    const order = ['daily', 'weekly', 'monthly'];
    return order.indexOf(a) - order.indexOf(b);
  });

  return (
    <div className="setting-form-config-section">
      <h3>Frequency</h3>
      <div className="setting-form-frequency-buttons">
        {['Daily', 'Weekly', 'Monthly'].map(freq => (
          <button 
            key={freq} 
            className={`setting-form-freq-btn ${frequency.includes(freq.toLowerCase()) ? 'active' : ''}`}
            onClick={() => handleButtonClick(freq.toLowerCase())}
          >
            {freq}
          </button>
        ))}
      </div>
      <div className="setting-form-selected-frequencies">
        Selected: {sortedSelected.length ? sortedSelected.join(' ') : 'None'}
        <br />
        <div>Next Forwarding Time:</div>
        {frequency.includes('daily') && <div>Daily reports: {nextReportTimes.daily}</div>}
        {frequency.includes('weekly') && <div>Weekly reports: {nextReportTimes.weekly}</div>}
        {frequency.includes('monthly') && <div>Monthly reports: {nextReportTimes.monthly}</div>}
      </div>
    </div>
  );
};

export default FrequencySelector;
